import { CoreUiInteractionEvent, generateTrackingKey } from "@obg/ngx.core";
import { TrackingContext } from "@obg/ngx.ui.core";

import {
	DepositBonusAction,
	DepositBonusInteractionContext,
	DepositLimitCalculatorEvent,
} from "./ui-interaction-telemetry.model";

export const MAT_COMMON_UI_INTERACTION_TRACKING_MAP: Record<string, any> = {
	[generateTrackingKey(TrackingContext.RegulatoryBarInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "SGAHeaderLogo",
	},
	[generateTrackingKey(
		DepositBonusInteractionContext.DepositBonusInteractionContext,
		DepositBonusAction.BonusSelectionOpen
	)]: {
		event: "BonusSelectionOpen",
	},
	[generateTrackingKey(
		DepositBonusInteractionContext.DepositBonusInteractionContext,
		DepositBonusAction.BonusSelectionClick
	)]: {
		event: "BonusSelectionClick",
	},
	[generateTrackingKey(
		TrackingContext.DepositLimitCalculatorInteractionContext,
		DepositLimitCalculatorEvent.LinkClick
	)]: {
		event: DepositLimitCalculatorEvent.LinkClick,
	},
};
